module.exports = __webpack_public_path__ + "static/desk-7a31fdf0c0c3f06c53671232946ad115.jpg";